export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_1-bbf89a001e6f29169deff6ffa8800beb.png";